module.exports = __webpack_public_path__ + "img/table.8c68cb16.png";